module.exports = __webpack_public_path__ + "img/icon_unchecked.57eae175.png";